import { MenuEntry } from '@src/menu-entry.js';

export default MenuEntry.create()
    .setTitle('Kasse')
    .setChildren([
        MenuEntry.create()
            .setTitle('Kasse')
            .setRoute('cash_desk'),
        MenuEntry.create()
            .setTitle('Transaktionen')
            .setChildren([
                MenuEntry.create()
                    .setRoute('cash_desk_my_transactions_list'),
                MenuEntry.create()
                    .setRoute('cash_desk_transactions_list'),
            ]),
        MenuEntry.create()
            .setTitle('Tagesabschluss')
            .setChildren([
                MenuEntry.create()
                    .setRoute('current_daily_balance'),
                MenuEntry.create()
                    .setRoute('finish_daily_balance'),
                MenuEntry.create()
                    .setRoute('cash_desk_my_daily_balance_list'),
                MenuEntry.create()
                    .setRoute('cash_desk_daily_balance_list'),
            ]),
        MenuEntry.create()
            .setTitle('Geldtransfer')
            .setChildren([
                MenuEntry.create()
                    .setRoute('cash_desk_cash_deposit'),
                MenuEntry.create()
                    .setRoute('cash_desk_cash_withdrawal'),
            ]),
        MenuEntry.create()
            .setTitle('Einstellungen')
            .setChildren([
                MenuEntry.create()
                    .setRoute('cash_desk_settings_terminal_diagnosis'),
                MenuEntry.create()
                    .setRoute('cash_desk_transfer_transaction_template_list'),
            ]),
        MenuEntry.create()
            .setRoute('dsfinvk_export_list')
            .setAdditionalRoutes([
                'dsfinvk_export_create',
                'dsfinvk_export_download',
            ]),
    ]);
